const scrollDownButton = () => {
  const hyperlinks = document.getElementsByTagName("a");
  for (let i = 0; i < hyperlinks.length; i++) {
    hyperlinks[i].onclick = function (ev) {
      const header = document.querySelector('.kirinus-header');
      if(this.classList.contains('kirinus-float-contact-link') || this.classList.contains('kirinus-job-openings-overview-filter--mobile-button') || this.classList.contains('btn-kirinus-filter') || this.classList.contains('kirinus-carousel-card--toggle') ) return;
      if (this.classList.contains('kirinus-scroll-down')) {
        window.scrollBy({
          top: 100,
          left: 0,
          behavior: 'smooth'
        });
      } else {

        let link_container;

        if (this.hash != '' && this.hash != '#!') {
          if(this.classList.contains('kirinus-wide-dropdown--link')){

            let dropdown = this.closest('.kirinus-wide-dropdown');
            dropdown.previousElementSibling.click();
          }
          link_container = document.querySelector(this.hash);
        } else if (this.attributes[0].nodeValue.startsWith('#') || this.attributes[0].nodeValue.startsWith('#!')) {
          //link_container = this.closest('.kirinus-field-content').nextElementSibling;
          let allFieldContent = document.querySelectorAll('.kirinus-field-content');
          link_container = allFieldContent[0];
        }

        if ((this.hash != '' || this.attributes[0].nodeValue.startsWith('#')) && link_container) {
          ev.preventDefault();
         // ev.stopPropagation();

          window.scrollTo({
            top: link_container.offsetTop - header.scrollHeight,
            behavior: 'smooth'
          })
        }
      }
    };
  }
}
export default scrollDownButton;
